import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Table } from 'react-bootstrap';

import JobRow from './JobRow'
import Loading from '../../components/Loading';

const JobTable = ({
  jobs,
  showEditModal,
  showEditNumberModal,
  showApplicantListModal,
  showNotificationModal,
  showApproveJobModal,
  showCancelJobModal,
  fields,
  getJobs,
  hasMore,
  dataLength,
  loading,
  confirmWireCheck
}) => {
  if (loading && !jobs.length) return <Loading />
  return (
    <InfiniteScroll
      dataLength={dataLength || jobs.length}
      next={getJobs}
      hasMore={hasMore}
      loader={<h4>Loading...</h4>}
    >
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            {fields.map(field => {
              return <th key={field.title}>{field.title}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {
            jobs.map((job) => {
              return (
                <JobRow
                  key={job.swipecast_job_id}
                  fields={fields}
                  showEditModal={showEditModal}
                  showApplicantListModal={showApplicantListModal}
                  showNotificationModal={showNotificationModal}
                  showEditNumberModal={showEditNumberModal}
                  showApproveJobModal={showApproveJobModal}
                  showCancelJobModal={showCancelJobModal}
                  confirmWireCheck={confirmWireCheck}
                  job={job}
                />
              )
            })
          }
        </tbody>
      </Table>
    </InfiniteScroll>
  );
}

export default JobTable;
